import { ExternalCalendarEvent } from '@griply/types';
import { isAfter } from 'date-fns';

export const hasExternalCalendarEventEnded = (
  event: ExternalCalendarEvent,
  now: Date,
): boolean => {
  // all-day events carry only a date (no time-of-day end) → never "ended" while shown for the day
  if (!event.end.dateTime) {
    return false;
  }
  return isAfter(now, new Date(event.end.dateTime));
};
